import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { DropPlaceholderComponent, customViewSortingOrGroupingPaneDragHandleStyle, DragHandle, groupingPaneDragPreviewComponent, groupingPaneRenderItem, DropPlaceholderComponentForGroupingAndSortingPane } from "csi/middleware/customView/data/dnd/data-management-tab-components";
import CheckboxOption from "csi/middleware/customView/options/CheckboxOption";
import DragPreviewLayer from "designSystem/dnd/components/DragPreviewLayer";
import { DndMode, DndStore, DndStoreContext, DragAndColumnDropWrapper } from "designSystem/dnd/index";
import { useSyncLocalStore } from "designSystem/hooks";
import { Button, GridColumn, GridRow, Text } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { DND_TYPE, GroupingLevel, useCustomViewGroupingStore } from "./CustomViewGroupingStore";
import CustomViewRowAndColumnGroupingLevel from "./CustomViewRowAndColumnGroupingLevel";

const customViewGroupingPaneDropTypes = [DND_TYPE.GROUPING_LEVEL];

const CustomViewGroupingPane: FunctionComponent = observer((props) => {
	const {
		addGroupingLevel,
		addRowAttributeGroupingLevel,
		addColumnAttributeGroupingLevel,
		columnAttributeGroupingLevel,
		dropItem,
		expandAllGroups,
		isGroupOptionEnabled,
		groupingList,
		rowAttributeGroupingLevel,
		setExpandAllGroups,
	} = useCustomViewGroupingStore();

	const dndStore = useSyncLocalStore(() => new DndStore<GroupingLevel>());
	const { dragItem } = dndStore;
	
	return (
		<Accordion data-csi-automation="CustomViewGroupingPane">
			<AccordionSummary>
				<Text res="CustomViewGroupingPane" semiBold />
			</AccordionSummary>
			<AccordionDetails>
				<GridColumn>	
					{isGroupOptionEnabled ? (
						<>
							<AccordionSummary>
								<Text res="CustomViewColumnAttribute" semiBold />
							</AccordionSummary>
							{columnAttributeGroupingLevel &&
								<CustomViewRowAndColumnGroupingLevel index={0} />
							}
							<GridRow spacingAroundY={1}>
								<Button
									design="outline"
									disabled={!!columnAttributeGroupingLevel}
									onClick={addColumnAttributeGroupingLevel}
									res="CustomViewAddGroupLevel"
								/>
							</GridRow>
							<AccordionSummary>
								<Text res="CustomViewRowAttribute" semiBold />
							</AccordionSummary>
							{rowAttributeGroupingLevel &&
								<CustomViewRowAndColumnGroupingLevel index={1} />
							}
							<GridRow spacingAroundY={1}>
								<Button
									design="outline"
									disabled={!!rowAttributeGroupingLevel}
									onClick={addRowAttributeGroupingLevel}
									res="CustomViewAddGroupLevel"
								/>
							</GridRow>
							<GridRow spacingAroundY={2}>
								<CheckboxOption
									label="CustomViewGroupPaneExpandAllGroups"
									onChange={setExpandAllGroups}
									optionValue={expandAllGroups}
									paddingBottom={0}
									paddingLeft={0}
								/>
							</GridRow>
						</>
					) : (
						<>
							<DndStoreContext.Provider value={dndStore}>
								<DragAndColumnDropWrapper<GroupingLevel>
									canDrag
									disableBgColorChangeOnDrag
									dragHandle={DragHandle}
									dragHandleStyle={customViewSortingOrGroupingPaneDragHandleStyle}
									dragType={DND_TYPE.GROUPING_LEVEL}
									dropPlaceholder={DropPlaceholderComponentForGroupingAndSortingPane}
									dropTypes={customViewGroupingPaneDropTypes}
									isFullScreen
									isRootDropWrapper
									list={groupingList}
									mode={DndMode.Normal}
									onDrop={dropItem}
									renderItem={groupingPaneRenderItem}
								/>
								{dragItem instanceof GroupingLevel && <DragPreviewLayer previewComponent={groupingPaneDragPreviewComponent} />}
							</DndStoreContext.Provider>
							<GridRow 
								data-csi-automation="CustomViewGroupingButtons"
								spacingAroundY={1}
							>
								<Button
									design="outline"
									disabled={groupingList.length > 1}
									onClick={addGroupingLevel}
									res="CustomViewAddGroupLevel"
								/>
							</GridRow>
						</>
					)}
				</GridColumn>
			</AccordionDetails>
		</Accordion>
	);
});

export default CustomViewGroupingPane;